import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled DataGrid container to allow button overflow
export const StyledDataGridContainer = styled(Box)`
  height: calc(100% - 64px);
  width: 100%;

  // Styles for the pagination footer - same design as SupplierProductsDatagrid
  & .MuiDataGrid-footerContainer {
    min-height: 48px;
    height: 48px;
    background-color: ${({ theme }) => theme.colors.greys.lightest};
    justify-content: flex-start;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  & .MuiTablePagination-root {
    font-size: 14px;
  }

  & .MuiTablePagination-displayedRows {
    font-size: 14px;
    margin: 0;
  }
  & .MuiTablePagination-selectLabel {
    font-size: 14px;
    margin: 0;
  }
  & .MuiTablePagination-actions {
    margin-left: 8px;
  }
`;
